<div class="comment-holder" [ngClass]="{ 'multi-replies': comment.subComments?.length > 1, replied: comment.subComments?.length == 1, 'replies-closed': !showReplies, 'private-comment': markAsPrivate() }">
  <div *ngIf="!comment.isNew" class="comment-top">
    <div class="justify-content">
      <div class="flex-start" *ngIf="!markAsPrivate()">
        <span class="instructor-name" *ngIf="isInstructorComment()"
          ><span class="instructor-name-text"><i class="fa fa-user" aria-hidden="true"></i></span
        ></span>
        <span class="instructor-name"
          ><span [ngStyle]="{ color: comment.user?.displayName | hsl }" [ngClass]="{ 'instructor-name-text': isInstructorComment() }" [innerHTML]="comment.user?.displayName | mark : getFieldMarks('user.displayName')"></span
        ></span>
      </div>
      <div class="flex-end">
        <span class="comment-date oblique">{{ comment.date | customerDateTime }}</span>
      </div>
    </div>
  </div>
  <div class="comment-content justify-content">
    <div *ngIf="!editMode" class="flex-start">
      <p [innerHTML]="comment.title | mark : getFieldMarks('title')"></p>
      <div class="replies-button-box">
        <button
          *ngIf="!showReplies"
          (click)="openReplies()"
          class="btn btn-link normal-weight no-padding"
          [rlAria]="comment.subComments?.length + ' ' + ('comment.showReplies' | translate)"
          [rTabIndex]
          [rlStopPropagation]
          [id]="'display-replies' + searchResultsIndex">
          <span class="medium-text"><i class="fa fa-plus"></i></span>
          {{ comment.subComments?.length }} {{ 'comment.replies' | translate }}
        </button>
      </div>
      <div class="comments-action-box" *ngIf="comment.canReply">
        <button
          (click)="reply()"
          class="btn btn-link no-padding"
          accessibleTooltip
          [tooltip]="'btn.reply' | translate"
          triggers="manual"
          [rTabIndex]
          [rlStopPropagation]
          [id]="'reply-' + searchResultsIndex"
          [attr.aria-label]="'comment.reply.label' | translate : { text: comment.title }">
          <i class="fa fa-reply"></i>
          <span class="sr-only">{{ 'btn.reply' | translate }}</span>
        </button>
      </div>
    </div>
    <div *ngIf="!hideMenu && !editMode" class="flex-end">
      <rl-menu [actions]="actions" (onClick)="clickMenu($event)" id="comment-actions-{{ comment.attachedId }}" [elementName]="comment.title"></rl-menu>
    </div>
  </div>
  <rl-edit-comment class="display-content" *ngIf="editMode" [comment]="comment" [visibilityAllowed]="_visibilityAllowed" (onCancel)="cancelEditComment()" (onSave)="editComment($event)"></rl-edit-comment>
</div>
<div class="replies-box" [ngClass]="{ 'replies-hidden': !showReplies, replied: comment.subComments?.length == 1 }">
  <ul class="replies-list" *ngIf="newCommentReply || comment.subComments?.length > 0" (click)="closeReplies()" rlStopPropagation>
    <!-- add reply form -->
    <li class="reply-comment" *ngIf="newCommentReply" [rlStopPropagation]>
      <rl-edit-comment [comment]="newCommentReply" (onCancel)="cancelNewReply()" (onSave)="saveNewReply($event)"></rl-edit-comment>
    </li>
    <ng-container *ngIf="showReplies">
      <li class="reply-comment" *ngFor="let c of comment.subComments; let i = index" [rlStopPropagation] (click)="toggleSelectComment(c.parentAttachedId)">
        <rl-comment
          [comment]="c"
          [visibilityAllowed]="'public'"
          [hideMenu]="hideMenu"
          (onDelete)="deleteReply(i)"
          (onDeleteCanceled)="cancelReply(c.attachedId)"
          (onEditSaved)="saveReply($event)"
          [searchResults]="searchResults | startsWith : 'objectIndex' : searchResultsIndex + ',' + i"
          [searchResultsIndex]="searchResultsIndex + ',' + i">
        </rl-comment>
      </li>
    </ng-container>
  </ul>
</div>
